import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { HelperService } from './services/helper.service'
import { getLoggedUser } from './_helpers/LocalStorage'
import { GOOGLE_API_KEY } from './app.api'
import { setTablesConfigurations } from './_helpers/Table-settings'

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
	constructor(private readonly helperService: HelperService) { }

	private googleMapsLoaded: boolean = false

	@HostListener('window:beforeunload', ['$event'])
	public unloadNotification($event: any) {
		localStorage.removeItem('isForcedLogout')
		localStorage.removeItem('userIsBlocked')
		localStorage.removeItem('userIsInactive')
	}

	public ngOnInit() {
		const ipNotDefined: boolean = Boolean(
			this.helperService.getUserIp() == null
		)

		if (ipNotDefined) {
			this.helperService.setUserIp()
		}

		if (getLoggedUser()) {
			this.helperService.validateToken()
		}

		this.loadGoogleMapsAPI()		
		setTablesConfigurations()
	}

	public loadGoogleMapsAPI(): Promise<void> {
		if (this.googleMapsLoaded) {
			console.log('Google Maps API already loaded')
			return
		}

		console.log('Loading Google Maps API')

	 return new Promise((resolve, reject) => {
			const script = document.createElement('script')
			script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=drawing`
			script.async = true
			script.defer = true
			script.onload = () => {
				resolve()
			}
			script.onerror = error => {
				console.log('Error loading Google Maps API')
				this.googleMapsLoaded = false
		  reject(error)
			}

			document.body.appendChild(script)

			this.googleMapsLoaded = true
		})
	}
}
